/**
 * 精简版格式化工具，仅覆盖 StatisticCard 内部与 demo 中会用到的两种模式。
 * 更复杂的格式化需求请通过 `formatter` 回调传入自定义实现。
 *
 * - `percent_2_1_1`：保留 2 位小数、带正负号的百分比。例如 `0.152 → '+15.20%'`
 * - `currency_￥_2`：保留 2 位小数、千位分隔符的人民币金额。例如 `6666.66 → '￥6,666.66'`
 */
export type StatisticFormatMode = 'percent_2_1_1' | 'currency_￥_2'

export function format(
  value: number | string | null | undefined,
  mode: StatisticFormatMode,
): string {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  const num = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(num)) {
    return String(value)
  }

  if (mode === 'percent_2_1_1') {
    const percent = (num * 100).toFixed(2)
    const sign = num > 0 ? '+' : ''
    return `${sign}${percent}%`
  }

  if (mode === 'currency_￥_2') {
    const abs = Math.abs(num).toFixed(2)
    const [intPart, decPart] = abs.split('.')
    const withComma = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return `${num < 0 ? '-' : ''}￥${withComma}.${decPart}`
  }

  return String(value)
}